import React, {useState, useEffect} from "react";
import axios from "axios";
import { useDispatch } from 'react-redux';
import { navigate } from '@reach/router';
import styled from "styled-components";
import LienNoirST from "../DesignSystem/SelfTissus/LienNoir";
import { List } from 'antd';
import {Wrap} from "./ElementsMembre";
import SpinnerInlineST from "../DesignSystem/SpinnersST/SpinnerInline";

const Commande = styled.div`
display: flex;
flex-wrap: wrap;
gap: 20px;
& img {
  box-shadow: 0 0 5px 0 rgba(0,0,0,0.1);
  border-radius: 8px;
  width: 172px;
}
@media only screen and (max-width: 768px) {
  flex-direction: column;
  gap: 10px;
  flex-wrap: wrap !important;
  }
  `;

const ListItemStyled = styled(List.Item)`
border: 1px solid ${(props) => props.theme.grey01ST} !important;
border-radius: 8px;
padding: 20px;
margin: 0 0 20px 0;
box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
&>.ant-list-item-extra {
  display: flex;
  align-items: end;
  margin-inline-start: 0 !important;
}
@media only screen and (max-width: 768px) {
  flex-direction: column;
  gap: 10px;
  flex-wrap: wrap !important;
  &>.ant-list-item-extra {
    margin: 0 !important;
    &> div > a {
      padding: 5px 0;
    }
  }
  }
`;

const data = Array.from({ length: 2 }).map((_, i) => ({
    href: 'https://ant.design',
    title: `Atelier n° ${i}`,
    description:
      '',
    content:
      <Commande>
        <img
          width={172}
          alt="logo"
          src="https://selftissus.myshopify.com/cdn/shop/files/atelier-surjeteuse-3h.jpg?v=1698414685&width=823"
        />
        <div>
          <p>Date: 2021-09-01</p>
        </div>
      </Commande>
  }));



export default function MembreAteliersST({className}) {
  const [dataAteliers, setDataAteliers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {

    setIsLoading(true);
    axios.post(`/users/membreatelierliste`)
    .then((response) => {
      console.log("response", response);
      setDataAteliers(response.data?.Ateliers);
      setIsLoading(false);
    })
    .catch((err) => {
      console.log("err", err);
      setIsLoading(false);
      dispatch({type: "DELETE_USER"})
      navigate("/membre");
    });
  }, []);
console.log("dataAteliers", dataAteliers);
    return (
        <Wrap className={className}>
          {isLoading && <SpinnerInlineST/>}
          {dataAteliers?.Ateliers ? 
          <>
            <h3 className="center homemadeTitle initial orange">Mes ateliers</h3>
            
            <List style={{width:"100%"}}
                itemLayout="vertical"
                size="large"
                // pagination={{
                //     position: 'bottom',
                //     align: 'start',
                //     total: 15, // Total number of items
                //     showTotal: (total, range) => `Commande ${range[0]}-${range[1]} sur ${total} au total`, // Function to display the range of items and total
                //     defaultPageSize: 10, // Number of items per page by default
                //     defaultCurrent: 1, // Initial page
                //     pageSizeOptions: ['10', '20', '30'], // Options for changing the page size
                //     onChange: (page, pageSize) => {
                //       // Function to handle page change
                //     },
                //   }}
                  dataSource={data}
                // footer={""}
                renderItem={(item) => (
                <ListItemStyled
                    key={item.title}
                    extra={
                      <>
                    {/* <img
                        width={272}
                        alt="logo"
                        src="https://gw.alipayobjects.com/zos/rmsportal/mqaQswcyDLcXyDKnZfES.png"
                    /> */}
                    <div>
                    <LienNoirST display={"block"} lib={"Voir les détails"} href={"/atelier"}/>
                    </div>
                    </>
                    }
                >
                    <List.Item.Meta
                    title={<p>{item.title}</p>}
                    description={item.description}
                    />
                
                    {item.content}
                </ListItemStyled>
                )}
            />
            </> : <h3 className="center homemadeTitle initial orange">Vous n'avez pas d'ateliers</h3>}
        </Wrap>
  );
}
